import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TuiDialogContext } from '@taiga-ui/core';
import { injectContext } from '@taiga-ui/polymorpheus';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'app-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogConfirmComponent extends BaseResizableComponent {
  readonly context = injectContext<TuiDialogContext<boolean>>();

  apply() {
    this.context.completeWith(true);
  }

  cancel() {
    this.context.completeWith(false);
  }
}
